export default __webpack_public_path__ + "static/media/708.93d95af3.png";